
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import React, { useEffect } from 'react';
import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link,useNavigate } from "react-router-dom";
import PureCounter from "@srexi/purecounterjs";
import ConatctForm from '../Components/ContactForm';

// https://tech-backend-livid.vercel.app/api/email/
const Industries = () => {
    useEffect(() => {
        // Initialize AOS (Animate On Scroll)
        AOS.init();
    
        // Initialize Swiper
        const swiper = new Swiper('.review-swiper', {
          spaceBetween: 15,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            320: { slidesPerView: 3 },
            480: { slidesPerView: 1 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          },
        });
    
        // Initialize PureCounter
        new PureCounter({
          selector: '.purecounter',
          start: 0,
          end: 500,
          duration: 1,
          delay: 10,
          once: true,
          pulse: false,
          decimals: 0,
          legacy: true,
          filesizing: false,
          currency: false,
          formater: 'us-US',
          separator: false,
        });
    
        // Handle Scroll Event for Navbar Shadow
        const handleScroll = () => {
          const navbar = document.querySelector('.navbar');
          if (window.scrollY > 50) {
            navbar.classList.add('shadow');
          } else {
            navbar.classList.remove('shadow');
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        // Cleanup event listener on unmount
        return () => {
          window.removeEventListener('scroll', handleScroll);
          swiper.destroy();
        };
      }, []);
    
  return (
    <div>
   <Navbar/>
   <div class="container-fluid position-relative half-fluid cloudmins-container">
        <section class="history-area industrySection">
          <header >
            <h3 class="section-header">Industries We Work With</h3>
          </header>
            <div class="row g-4 position-relative z-index-10">
                <div class="col-md-4">
                    <div class="industry-card text-center p-4">
                        <i class="fa-solid fa-house-medical-flag industyicon"></i>
                        <h5>Healthcare</h5>
                        <p>Enhancing patient care with cutting-edge technology.</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="industry-card text-center p-4">
                        <i class="fa-solid fa-coins industyicon"></i>
                        <h5>Finance</h5>
                        <p>Secure and seamless financial solutions.</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="industry-card text-center p-4">
                        <i class="fa-solid fa-graduation-cap industyicon"></i>
                        <h5>Education</h5>
                        <p>Innovative e-learning and digital education platforms.</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="industry-card text-center p-4">
                        <i class="fa-solid fa-cart-shopping industyicon"></i>
                        <h5>E-Commerce</h5>
                        <p>Scalable solutions for online retail businesses.</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="industry-card text-center p-4">
                        <i class="fa-solid fa-truck-fast industyicon"></i>
                        <h5>Logistics</h5>
                        <p>Optimized supply chain and logistics management.</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="industry-card text-center p-4">
                        <i class="fa-solid fa-house-chimney industyicon"></i>
                        <h5>Real Estate</h5>
                        <p>Smart property management and real estate tech.</p>
                    </div>
                </div>
            </div>
        </section>
    
        {/* <!-- Why Choose Us --> */}
        <section class="choose-us-section">
            <div class="container">
              <header >
                <h3 class="section-header">Why Choose Us?</h3>
                <p class="lead">We deliver innovative solutions tailored to your industry's needs.</p>
              </header>               
                <div class="row mt-4">
                    <div class="col-md-4 experties-box">
                        <div class="feature-box">
                            <h4>Expertise</h4>
                            <p>Years of experience in industry-specific solutions.</p>
                        </div>
                    </div>
                    <div class="col-md-4 innovation-box">
                        <div class="feature-box">
                            <h4>Innovation</h4>
                            <p>Cutting-edge technology for modern business needs.</p>
                        </div>
                    </div>
                    <div class="col-md-4 support-box">
                        <div class="feature-box">
                            <h4>Support</h4>
                            <p>24/7 assistance to ensure smooth operations.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    
        {/* <!-- Contact Section --> */}
      <ConatctForm/>
    </div>
    <Footer/>

   
    </div>
  )
}

export default Industries